import { mfToken, httpGetAsync } from 'embed/helpers'
import data from 'backend-data/index.js.erb'
import 'embed/styles.css'

import 'embed/polyfills/closest.js';
import 'embed/polyfills/forEach.js';
import 'embed/polyfills/requestAnimFrame.js';
import 'embed/polyfills/includes.js';
import 'url-search-params-polyfill';
import { initMFBase, initMakeAnOffer } from '../embed/init.jsx';
import { createStore } from 'redux'
import reducers from 'embed/reducers'

const setSettingsAndInit = (settings, store) => {
  makeAnOfferData.settings = settings;
  initMakeAnOffer(store);
}

if (typeof makeAnOfferData == "object" && !navigator.userAgent.match(/(bot|Bot)/i)) {
  try {
    const store = createStore(reducers)
    if (typeof makeAnOfferData.settings != 'string') {
      const merchantToken = mfToken()
      httpGetAsync(`https://${data.hostUrl}/user_settings/${merchantToken}`, setSettingsAndInit, store)
    } else {
      initMakeAnOffer(store);
    }
    initMFBase(store);
  } catch (e) {
    console.error(e);
  }
} else if (!navigator.userAgent.match(/(bot|Bot)/i)) {
  console.info('makeAnOfferData is not defined');
}
